import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    question: {
        color: '#111',
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
    },
    subheading: {
        fontSize: '12px',
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        fontWeight: 500,
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const TdsVerification = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });

    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Scrutinise the creditors ledger to determine if TDS is applicable</Typography>
                {/* <Typography className={classes.subheading}></Typography> */}
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Enlist all such payments for which TDS is applicable and not deducted/short deducted{' '}
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Prepare TDS payment schedule as prescribed and obtain eTDS return and challans
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case of non deduction/short deduction, report it in clause 21(b) of Form 3CD is a seperate annexure
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    For all the expenses on which TDS provisions apply, collect and report details as provided in clause 34 of Form 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Obtain list of all TDS related disallowances in the previous years</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case any of them have been paid in the current year, consider for tax computation
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
        </Grid>
    );
};

export default TdsVerification;
